/* eslint-disable no-useless-escape */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useMemo, useRef, useState} from 'react'
import {Button} from 'react-bootstrap'
import {Link, useNavigate, useParams} from 'react-router-dom'
import {getCheckInitpwdKey, getUserByToken, saveNewPassword} from '../core/_requests'
import {useDispatch} from 'react-redux'
import {setMessageData} from '../../../common/ModalPopup/reducer'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {useAuth} from '../core/Auth'
import clsx from "clsx";
import {FormattedMessage} from "react-intl";

const ResetPasswordKeyCheck = () => {
  const {rpKey} = useParams()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const didRequest = useRef(false)
  const { logout, setCurrentUser, setAuthMessage, authMessage, saveAuth} = useAuth()
  const [isValidKey, setIsValidKey] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(true)
  const [password, setPassword] = useState<string>('')
  const [confirm, setConfirm] = useState<string>('')
  const [nonconformError, setNonconformError] = useState<string | null>(null)
  const [showedPassword,setShowedPassword] = useState<boolean>(false)
  const passwordRegex = new RegExp(
      "^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[£µ!@#\$%\^&\*\)\(\=\|\{\}\~\'\"])(?=.{8,})"
  );
  useEffect(() => {
    console.log('rpKey : ', rpKey)
    const checkPwdKey = async () => {
      if (rpKey && rpKey !== '') {
        const checkRes = await getCheckInitpwdKey(rpKey)
        if (checkRes && checkRes?.data?.Status?.Success) {
          setIsValidKey(true)
        } else {
          dispatch(
            setMessageData({
              Message: checkRes?.data?.Status?.Message,
              MessageType: checkRes?.data?.Status?.MessageType,
            })
          )
        }
        setLoading(false)
      }
    }
    checkPwdKey()
  }, [dispatch, rpKey])

  const requestUser = async (apiToken: string) => {
    try {
      if (!didRequest.current) {
        const {
          data: {
            data,
            Status: {Message},
          },
        } = await getUserByToken(apiToken)
        if (data) {
          setCurrentUser(data)
          navigate("/home")
        } else {
          if (Message && typeof Message === 'string') {
            setAuthMessage(Message)
          }
          logout()
          // setShowSplashScreen(false)
        }
      }
    } catch (error) {
      console.error(error)
      if (!didRequest.current) {
        logout()
      }
    } finally {
      // setShowSplashScreen(false)
    }

    return () => (didRequest.current = true)
  }

  const navigateToHome = () => {
    navigate('/login', {replace: true})
  }

  const handleValidateNewPasswordClick = async () => {
    setNonconformError('')
    setAuthMessage('')
    if (password && password !== '' && password === confirm) {
      if (!passwordRegex.test(confirm)) {
        setNonconformError('Le mot de passe doit contenir au moins 8 caractères dont des chiffres, des majuscules et minuscules et une caractère spéciale ! ou @ ou ( ou )')
      }
     else {
        const newPwd = await saveNewPassword({Key: rpKey || '', Password: password})
        if (newPwd?.data?.Status?.Success) {
          saveAuth(newPwd?.data?.data)
          requestUser(newPwd?.data?.data?.AccessToken)
        } else {
          setNonconformError(newPwd?.data?.Status?.Message)
        }
      }
    } else if (password !== confirm) {
      setNonconformError('Mot de passe non conforme')
    }
    else if (!password || !confirm) {
      setNonconformError('champs obligatoire')
    }
  }

  const isDisabled = useMemo(() => {
    return (!password || !confirm || !passwordRegex.test(confirm) || password !==confirm)
  }, [password, confirm, passwordRegex]);


  if (loading) {
    return (
      <div className='text-center p-5'>
        <div className='text-center mb-20'>
          <img src={toAbsoluteUrl('/media/images/Logo-Dark.png')} className='w-50' alt='Logo' />
        </div>
        <div>Chargement ...</div>
      </div>
    )
  }
  if (!loading && !isValidKey) {
    return (
      <div className='text-center'>
        <div className='text-center mb-20'>
          <img src={toAbsoluteUrl('/media/images/Logo-Dark.png')} className='w-25' alt='Logo' />
        </div>
        <div className='p-5 text-danger '>La clé est invalide</div>
        <div className='p-5'>
          <Button variant='primary' onClick={navigateToHome}>
            Se connecter
          </Button>
        </div>
      </div>
    )
  }

  return (
    <div className='d-flex flex-column align-items-center p-5 '>
      <div className='text-center mb-2'>
        <img src={toAbsoluteUrl('/media/images/Logo-Dark.png')} className='w-25' alt='Logo' />
      </div>
      <div className='p-2'>
        <h4>Réinitialiser votre mot de passe</h4>
      </div>
      <div className='text-danger pb-4'>{authMessage}</div>
      {nonconformError && nonconformError !== '' && (
        <div className='text-danger pb-2'>{nonconformError}</div>
      )}
      <div
        className='p-5 rounded w-100 w-md-25 w-lg-25'
        style={{
          backgroundColor: '#CACACA',
          minWidth: "30%"
        }}
      >
        <div className='form-group  mt-3'>
          <label className='mb-1'>Nouveau mot de passe</label>
          <div className="position-relative mb-3">
            <input
                type={showedPassword ? "text":"password"}
                className='form-control form-control-lg form-control-solid bg-gray'
                placeholder='Nouveau mot de passe'
                onChange={(e) => {
                  setPassword(e?.target?.value)
                }}
            />
            <span
                className="btn btn-sm btn-icon position-absolute translate-middle top-50 end-0 me-n2"
                onClick={() => setShowedPassword(!showedPassword)}
            >
                          <i className={clsx("fs-2",{
                            "bi bi-eye-slash-fill":!showedPassword,
                            "bi bi-eye-fill":showedPassword
                          })}></i>
                      </span>
          </div>
        </div>
        <div className='form-group  mt-3'>
          <label className='mb-1'>Confirmer le mot de passe</label>
          <div className="position-relative mb-3">
            <input
                type={showedPassword ? "text":"password"}
                className='form-control form-control-lg form-control-solid bg-gray'
                id='confirmpassword'
                placeholder='Confirmer le mot de passe'
                onChange={(e) => {
                  setConfirm(e?.target?.value)
                }}
            />
            <span
                className="btn btn-sm btn-icon position-absolute translate-middle top-50 end-0 me-n2"
                onClick={() => setShowedPassword(!showedPassword)}
            >
                          <i className={clsx("fs-2",{
                            "bi bi-eye-slash-fill":!showedPassword,
                            "bi bi-eye-fill":showedPassword
                          })}></i>
                      </span>
          </div>
        </div>
        <div className='my-3'>
            <FormattedMessage
                id='PASSWORD_CRITERIA_ERROR'
                defaultMessage="Le mot de passe doit contenir au moins 8 caractères dont des chiffres, des majuscules et minuscules et une caractère spéciale ! ou @ ou ( ou )"/>
        </div>
        <div className='row align-items-center gap-3 gap-md-9 '>
          <div className='col-4 col-md-3 '>
            <Button variant='primary' disabled={isDisabled} style={{cursor: isDisabled ? 'not-allowed':'pointer'}} onClick={handleValidateNewPasswordClick}>
              Réinitialiser
            </Button>
          </div>
          <div className='col-6  col-md-4 mx-md-3'>
            <Link to={'/login'} className='text-black py-3'>Se connecter</Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ResetPasswordKeyCheck
